import useAuth from "./useAuth";
import axios from "../api/axios";

const useRefreshToken = () => {
  const { setAuth } = useAuth();

  const refresh = async () => {

    const response = await axios.get("/api/refresh-token", {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    });

    setAuth((prev) => {
      return {
        ...prev,
        username: response.data.username,
        name: response.data.name,
        roles: response.data.role,
        accessToken: response.data.accessToken,
        franchise_id: response.data.franchise_id,
        franchise_name: response?.data?.franchise_name,
        business_type: response?.data?.business_type,
        parent_franchise_id: response?.data?.parent_franchise_id,
      };
    });
    return response.data.accessToken;
  };

  return refresh;
};

export default useRefreshToken;
